// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1l-q";
export var animationRelative = "_1l-p";
export var backdropBlur = "_1l-0";
export var detailLabelCell = "_1l-12";
export var detailTable = "_1l-11";
export var detailValueCell = "_1l-13";
export var docIconBox = "_1l-1d";
export var docIconBoxMd = "_1l-1f";
export var docIconBoxSm = "_1l-1e";
export var docTypeRow = "_1l-16";
export var docTypeRowInner = "_1l-17";
export var dropdownMatchDatePicker = "_1l-3";
export var evidenceCardContent = "_1l-1c";
export var fileUploadSpin = "_1l-j";
export var gorgiasOpenButton = "_1l-15 _1l-d";
export var gorgiasTicketCard = "_1l-14";
export var heroModalFooterButton = "_1l-18";
export var hiddenContainer = "_1l-o";
export var iconPrimary = "_1l-1g";
export var iconQuaternary = "_1l-1i";
export var iconTertiary = "_1l-1h";
export var integrationCard = "_1l-1";
export var integrationLogoBox = "_1l-2";
export var mainColumnSticky = "_1l-1b";
export var maxWidthContainer = "_1l-19";
export var modalContentBody = "_1l-a";
export var modalHeaderImage = "_1l-5";
export var modalImageLabel = "_1l-7";
export var modalImageOverlay = "_1l-6";
export var modalImageSubtitle = "_1l-9";
export var modalImageTitle = "_1l-8";
export var modalImageWrapper = "_1l-4";
export var modalStickyFooter = "_1l-b";
export var removeButton = "_1l-e";
export var sidebarColumn = "_1l-1a";
export var spinner = "_1l-i";
export var timelineLine = "_1l-y";
export var timelineLineBlack = "_1l-10 _1l-y";
export var timelineLineGray = "_1l-z _1l-y";
export var timelineLineHeight = "_1l-x";
export var tlDotActivate = "_1l-u";
export var tlDotActivateAnim = "_1l-t";
export var tlDotHide = "_1l-s";
export var tlDotHideAnim = "_1l-r";
export var tlLineActivate = "_1l-w";
export var tlLineActivateAnim = "_1l-v";
export var uploadHint = "_1l-n";
export var uploadIconBox = "_1l-k";
export var uploadLabel = "_1l-m";
export var uploadText = "_1l-l";
export var uploadZone = "_1l-f";
export var uploadZoneCursorDefault = "_1l-h";
export var uploadZoneCursorPointer = "_1l-g";
export var uploadedFileRow = "_1l-c";
export var viewButton = "_1l-d";